import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  SelectChangeEvent,
  Chip,
} from "@mui/material";
import getTabsByRole from "../../../../../common/utils/UserWiseRole";
import RolesId from "../../../../../common/enums/RoleIds";

interface DeviationTableMobileProps {
  month: number;
  year: number;
  ga_code: string;
  userTourCardData: any;
  userRoleId: number;
    autoSelectedTab?: string; // NEW
  // onTabSwitch?: (payload: any) => void;
    onTabSwitchTour?: (payload: any) => void;   // ADD
  onTabSwitchUser?: (payload: any) => void;   // RENAME old
}

const DeviationTableMobile: React.FC<DeviationTableMobileProps> = ({
  userTourCardData,
  userRoleId,
  month,
  year,
  autoSelectedTab,
  // onTabSwitch,
    onTabSwitchTour,
      onTabSwitchUser,
  ga_code,
})  => {
 
  const allowedTabs = getTabsByRole(userRoleId);

const [selectedTab, setSelectedTab] = useState(
  autoSelectedTab && allowedTabs.includes(autoSelectedTab)
    ? autoSelectedTab
    : allowedTabs[0]
);

  const [sortOrder, setSortOrder] = useState<"Highest" | "Lowest">("Highest");

  useEffect(() => {
  if (autoSelectedTab && allowedTabs.includes(autoSelectedTab)) {
    setSelectedTab(autoSelectedTab);
  }
}, [autoSelectedTab]);


  const apiUsers = userTourCardData?.users ?? [];

const mappedData = useMemo(
  () =>
    apiUsers.map((u: any) => ({
      name: u.user_name,
      area: u.territory_name,
      deviation: u.deviation_percentage,
    })),
  [apiUsers] // 🟢 direct dependency
);


  const tabWiseData: Record<string, typeof mappedData> = {
    ZBM: mappedData, 
    RBM: mappedData,
    ABM: mappedData,
    TSO: mappedData,
    Self: mappedData,
  };

const handleTabChange = (_: any, newValue: string) => {
  setSelectedTab(newValue);

  // 🔥 Reset sort order whenever tab is changed
  setSortOrder("Highest");

  const commonPayload: any = {
    month: month.toString().padStart(2, "0"),
    year,
    ga_code,
    sort_order: "DESC", // default backend sort for Highest
  };

  if (newValue === "Self") {
    onTabSwitchTour?.({ action: "clear" });
    onTabSwitchUser?.({ action: "clear" });
    return;
  }

  const roleMap: any = {
    ZBM: RolesId.ZONE_MANAGER,
    RBM: RolesId.REGION_MANAGER,
    ABM: RolesId.AREA_MANAGER,
    TSO: RolesId.HEADQUATER_MANAGER,
  };

  const rolePayload = {
    ...commonPayload,
    role_id: roleMap[newValue],
  };

  onTabSwitchTour?.(rolePayload);
  onTabSwitchUser?.(rolePayload);
};


const handleSortChange = (event: SelectChangeEvent) => {
  const newSortOrder = event.target.value as "Highest" | "Lowest";
  setSortOrder(newSortOrder);

  const payload: any = {
    month: month.toString().padStart(2, "0"),
    year,
    ga_code,
    sort_order: newSortOrder === "Highest" ? "DESC" : "ASC",
  };

  if (selectedTab === "Self") {
    payload.scope = "self";
    onTabSwitchUser?.(payload);   // call user API
    onTabSwitchTour?.(payload);   // call tour API
  } else {
    if (selectedTab === "ZBM") payload.role_id = RolesId.ZONE_MANAGER;
    if (selectedTab === "RBM") payload.role_id = RolesId.REGION_MANAGER;
    if (selectedTab === "ABM") payload.role_id = RolesId.AREA_MANAGER;
    if (selectedTab === "TSO") payload.role_id = RolesId.HEADQUATER_MANAGER;

    onTabSwitchUser?.(payload);   // call user API
    onTabSwitchTour?.(payload);   // call tour API
  }
};

  const sortedData = [...tabWiseData[selectedTab]].sort((a, b) =>
    sortOrder === "Highest"
      ? b.deviation - a.deviation
      : a.deviation - b.deviation
  );
  const noData = !sortedData || sortedData.length === 0;

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: 2,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        overflow: "hidden",
      }}
    >
      {/* Title + Sort */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          pt: 2,
          pb: 1,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Member Wise Details
        </Typography>

        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
            Sort:
          </Typography>
          <Select
            size="small"
            value={sortOrder}
            onChange={handleSortChange}
            renderValue={(value) => (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <span style={{ fontSize: "0.75rem" }}>
                  {value === "Highest" ? "↓" : "↑"}
                </span>
              </Box>
            )}
            sx={{
              minWidth: 50,
              fontSize: "0.8rem",
              "& .MuiSelect-select": {
                py: 0.5,
                pr: 2.5,
              },
            }}
          >
            <MenuItem value="Highest" sx={{ fontSize: "0.8rem" }}>
              Highest to Lowest
            </MenuItem>
            <MenuItem value="Lowest" sx={{ fontSize: "0.8rem" }}>
              Lowest to Highest
            </MenuItem>
          </Select>
        </Box>
      </Box>

      {/* Tabs */}
     {/* Tabs */}
<Box
  sx={{
    px: 2,
    pb: 1,
    borderBottom: "1px solid #e0e0e0",
    overflowX: "auto",       
    whiteSpace: "nowrap",    
    scrollbarWidth: "thin",  
    "&::-webkit-scrollbar": {
      height: 6,
    },
  }}
>
  <Tabs
    value={selectedTab}
    onChange={handleTabChange}
    variant="scrollable"     
    scrollButtons="auto"         
    allowScrollButtonsMobile   
    sx={{
      minHeight: 40,
      width: "max-content",      
      "& .MuiTab-root": {
        textTransform: "none",
        minWidth: 80,
        minHeight: 40,
        px: 1.5,
        py: 1,
        fontSize: "0.875rem",
        fontWeight: 500,
        color: "#666",
        "&.Mui-selected": {
          color: "#2196f3",
          fontWeight: 600,
        },
      },
      "& .MuiTabs-indicator": {
        backgroundColor: "#2196f3",
        height: 3,
      },
    }}
  >
    {allowedTabs.map((tab) => (
      <Tab key={tab} label={tab} value={tab} />
    ))}
  </Tabs>
</Box>


      {/* Table */}
    <TableContainer sx={{ maxHeight: 400 }}>
  <Table
    stickyHeader
    sx={{
      tableLayout: "fixed", 
      width: "100%",
      "& .MuiTableCell-root": {
        fontSize: "0.85rem",
        py: 1.5,
        px: 2,
        whiteSpace: "normal",       
        wordBreak: "break-word",    
        overflowWrap: "break-word",
      },
      "& .MuiTableCell-head": {
        bgcolor: "#fafafa",
        fontWeight: 700,
        color: "#000",
        borderBottom: "2px solid #e0e0e0",
      },
    }}
  >
    <TableHead>
      <TableRow>
        <TableCell>Name</TableCell>
        <TableCell>Brick/Area/HQ</TableCell>
        <TableCell align="right">Deviation</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {noData ? (
        <TableRow>
          <TableCell colSpan={3} align="center" sx={{ py: 2 }}>
            <Typography color="text.secondary" fontStyle="italic">
              No deviations found
            </Typography>
          </TableCell>
        </TableRow>
      ) : (
        sortedData.map((row) => (
          <TableRow
            key={row.name + row.area}
            sx={{
              "&:hover": { bgcolor: "#f5f5f5" },
              "&:last-child td": { border: 0 },
            }}
          >
            <TableCell>{row.name}</TableCell>
            <TableCell>
              <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                {row.area}
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Chip
                label={`${row.deviation}%`}
                size="small"
                sx={{
                  color:
                    row.deviation < 20
                      ? "green"
                      : row.deviation < 50
                      ? "orange"
                      : "red",
                  fontWeight: 600,
                  fontSize: "0.8rem",
                  height: 24,
                  minWidth: 50,
                }}
              />
            </TableCell>
          </TableRow>
        ))
      )}
    </TableBody>
  </Table>
</TableContainer>
    </Box>
  );
};

export default DeviationTableMobile;
